export default "__VITE_ASSET__CHxRcLlu__"